import {
  Actions,
  GET_TEAMS_FOR_PROJECT,
  GET_TEAMS_FOR_PROJECT_FAILED,
  GET_TEAMS_FOR_PROJECT_SUCCEEDED,
  GET_TEAM,
  GET_TEAMS,
  GET_TEAMS_FAILED,
  GET_TEAMS_SUCCEEDED,
  GET_TEAM_SUCCEEDED,
  UPDATE_TEAM_SUCCEEDED,
  GET_TEAM_FAILED,
  GET_PROJECTS_FOR_TEAM,
  GET_PROJECTS_FOR_TEAM_FAILED,
  GET_PROJECTS_FOR_TEAM_SUCCEEDED,
  GET_TEAMS_FOR_POPOVER,
  GET_TEAMS_FOR_POPOVER_SUCCEEDED,
  CLEAR_TEAMS_REDUCER_BY_KEY,
  GET_USERS_IN_TEAM,
  GET_USERS_IN_TEAM_SUCCEEDED,
} from './actions';
import { ITeamsState } from './types';

const initialState: ITeamsState = {
  list: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: 0,
  },
  team: null,
  loading: false,
  teamsForProjectList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: 0,
  },
  projectsForTeamList: {
    total: 0,
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
  },
  teamMembersForTeamList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
    total: 0,
  },
  teamsForPopoverList: {
    items: [],
    loading: false,
    queriedAtLeastOnce: false,
  },
};

const reducer = (
  state: ITeamsState = initialState,
  action: Actions
): ITeamsState => {
  switch (action.type) {
    case GET_TEAMS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
        },
      };

    case GET_TEAMS_SUCCEEDED:
      return {
        ...state,
        list: {
          items: action.payload.shouldAppend
            ? [...state.list.items, ...action.payload.teams]
            : action.payload.teams,
          loading: false,
          queriedAtLeastOnce: true,
          total: action.payload.total,
        },
      };

    case GET_TEAMS_FAILED:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
        },
      };

    case GET_TEAM:
      return {
        ...state,
        team: null,
        loading: true,
      };

    case UPDATE_TEAM_SUCCEEDED:
    case GET_TEAM_SUCCEEDED:
      return {
        ...state,
        team: action.payload.team,
        loading: false,
        list: {
          ...state.list,
          items: [
            ...state.list.items.map((team) =>
              team.id === action.payload.team?.id
                ? {
                    ...team,
                    name: action.payload.team.name,
                    hasLogo: action.payload.team.hasLogo,
                    requiresRequestToJoin:
                      action.payload.team.requiresRequestToJoin,
                    teamAdmins: action.payload.team.teamAdmins,
                  }
                : team
            ),
          ],
        },
      };

    case GET_TEAM_FAILED:
      return {
        ...state,
        loading: false,
      };

    case GET_TEAMS_FOR_PROJECT:
      return {
        ...state,
        teamsForProjectList: {
          ...state.teamsForProjectList,
          loading: true,
          items:
            action.payload.page === 1 || action.payload.page === undefined
              ? []
              : state.teamsForProjectList.items,
        },
      };

    case GET_TEAMS_FOR_PROJECT_SUCCEEDED:
      return {
        ...state,
        teamsForProjectList: {
          items: [...state.teamsForProjectList.items, ...action.payload.teams],
          total: action.payload.total,
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case GET_TEAMS_FOR_PROJECT_FAILED:
      return {
        ...state,
        teamsForProjectList: {
          ...state.teamsForProjectList,
          loading: false,
        },
      };

    case GET_PROJECTS_FOR_TEAM:
      return {
        ...state,
        projectsForTeamList: {
          ...state.projectsForTeamList,
          loading: true,
        },
      };

    case GET_PROJECTS_FOR_TEAM_SUCCEEDED:
      return {
        ...state,
        projectsForTeamList: {
          total: action.payload.total,
          items: action.payload.shouldAppend
            ? [...state.projectsForTeamList.items, ...action.payload.projects]
            : action.payload.projects,
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case GET_PROJECTS_FOR_TEAM_FAILED:
      return {
        ...state,
        projectsForTeamList: {
          ...state.projectsForTeamList,
          loading: false,
        },
      };

    case GET_TEAMS_FOR_POPOVER:
      return {
        ...state,
        teamsForPopoverList: {
          ...state.teamsForPopoverList,
          loading: true,
        },
      };

    case GET_TEAMS_FOR_POPOVER_SUCCEEDED:
      return {
        ...state,
        teamsForPopoverList: {
          items: action.payload,
          loading: false,
          queriedAtLeastOnce: true,
        },
      };

    case GET_USERS_IN_TEAM:
      return {
        ...state,
        teamMembersForTeamList: {
          ...state.teamMembersForTeamList,
          loading: true,
        },
      };

    case GET_USERS_IN_TEAM_SUCCEEDED:
      return {
        ...state,
        teamMembersForTeamList: {
          items: action.payload.shouldAppend
            ? [...state.teamMembersForTeamList.items, ...action.payload.users]
            : action.payload.users,
          loading: false,
          queriedAtLeastOnce: true,
          total: action.payload.total,
        },
      };

    case CLEAR_TEAMS_REDUCER_BY_KEY:
      return {
        ...state,
        [action.payload]: initialState[action.payload],
      };
    default:
      return state;
  }
};

export default reducer;
